import {
  isHttpError
} from "./chunk-KKRZEVOT.js";

// src/utils/object.ts
import { isPlainObject } from "es-toolkit";
var isRecord = (value) => isPlainObject(value);
var isRangeDto = (value) => {
  if (!isRecord(value)) return false;
  return "min" in value || "max" in value;
};
var isKey = (x, k) => {
  return k in x;
};
var getEntries = (obj) => Object.entries(obj);
var getKeys = (obj) => Object.keys(obj);

// src/utils/error.ts
var isErrorDetails = (data) => {
  return isRecord(data) && "traceId" in data && "details" in data;
};
var createError = (error) => {
  if (isHttpError(error) || error instanceof Error) {
    return error;
  } else if (isRecord(error) && "message" in error) {
    return new Error(error.message);
  } else if (typeof error === "string") {
    return new Error(error);
  } else {
    return new Error("An unknown error occurred.");
  }
};
var getErrorMessage = (error) => {
  if (isHttpError(error) && error.response) {
    const { data, status } = error.response;
    return `HttpError: ${status} - ${isErrorDetails(data) ? data.details : JSON.stringify(data)}`;
  } else {
    return error.message;
  }
};
var getErrorResult = (error, metadata) => {
  const parsedError = createError(error);
  return {
    status: "error",
    error: parsedError,
    statusCode: isHttpError(parsedError) ? parsedError.response?.status ?? 500 : 500,
    data: isHttpError(parsedError) ? parsedError.response?.data : void 0,
    errorMessage: getErrorMessage(parsedError),
    metadata
  };
};

export {
  isRecord,
  isRangeDto,
  isKey,
  getEntries,
  getKeys,
  getErrorResult
};
